var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.close,
          expression: "close"
        }
      ]
    },
    [
      _c(
        "button",
        {
          staticClass: "offer-search__dropdown-button",
          class: { "offer-search__dropdown-button--active": _vm.open },
          on: {
            click: [
              _vm.toggle,
              function($event) {
                $event.stopPropagation()
              }
            ]
          }
        },
        [
          _c("span", { staticClass: "screen-reader-text" }, [
            _vm._v("Avaa valikko")
          ])
        ]
      ),
      _vm._v(" "),
      _vm.open
        ? _c(
            "div",
            {
              staticClass: "offer-search__dropdown",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                }
              }
            },
            [
              _c(
                "button",
                {
                  staticClass: "offer-search__action-button",
                  on: {
                    click: [
                      _vm.copy,
                      function($event) {
                        $event.stopPropagation()
                      }
                    ]
                  }
                },
                [_vm._v("\n      Kopioi\n    ")]
              ),
              _vm._v(" "),
              _vm.currentUserCanDelete
                ? _c(
                    "button",
                    {
                      staticClass: "offer-search__action-button",
                      on: {
                        click: [
                          _vm.confirmDeletion,
                          function($event) {
                            $event.stopPropagation()
                          }
                        ]
                      }
                    },
                    [_vm._v("\n      Poista\n    ")]
                  )
                : _vm._e()
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("delete-offer-modal", {
        attrs: {
          "offer-id": _vm.offerId,
          display: _vm.displayDeleteConfirmation,
          nonce: _vm.nonce
        },
        on: {
          cancel: function($event) {
            _vm.displayDeleteConfirmation = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-25661978", { render: render, staticRenderFns: staticRenderFns })
  }
}